function loadTomSelectJs() {

    if ($(".tomselect-style").length === 0) {
        return;
    }

    if (typeof TomSelect !== "undefined") {
        initTomSelectboxes();
        return;
    }

    $.ajax({
        url: "https://cdn.jsdelivr.net/npm/tom-select@2.4.3/dist/js/tom-select.complete.min.js",
        async: true,
        dataType: "script",
        success: function () {
            var head = document.getElementsByTagName("HEAD")[0];
            var csslink = document.createElement("link");
            csslink.rel = "stylesheet";
            csslink.type = "text/css";
            csslink.href = "https://cdn.jsdelivr.net/npm/tom-select@2.4.3/dist/css/tom-select.default.min.css";
            head.appendChild(csslink);
            initTomSelectboxes();
        }
    });
}

function initTomSelectboxes() {

    if (typeof TomSelect === "undefined") {
        return;
    }

    $(".tomselect-style").each(function () {
        var $wrapper = $(this);
        var $select = $wrapper.find("select").first();

        if ($select.length === 0) {
            return;
        }

        if ($select[0].tomselect) {
            return;
        }

        var ts = new TomSelect($select[0], {
            create: false,
            allowEmptyOption: true,
            searchField: ["text"],
            maxOptions: 500,
            render: {
                option: function (data, escape) {
                    if (!data.value) {
                        return "<div class='option option--empty-hidden' style='display:none;'></div>";
                    }
                    return "<div>" + escape(data.text) + "</div>";
                }
            },
            onInitialize: function () {
                updateTomSelectWrapperState($wrapper, this);
            },
            onFocus: function () {
                $wrapper.addClass("focused");
                updateTomSelectWrapperState($wrapper, this);
            },
            onBlur: function () {
                $wrapper.removeClass("focused");
                updateTomSelectWrapperState($wrapper, this);
            },
            onChange: function (value) {
                $select.val(value);
                $select.trigger("change");
                updateTomSelectWrapperState($wrapper, this);
            }
        });

        updateTomSelectWrapperState($wrapper, ts);
    });
}

function updateTomSelectWrapperState($wrapper, tsInstance) {
    var hasValue = false;

    if (tsInstance && tsInstance.getValue) {
        hasValue = tsInstance.getValue() !== "";
    }

    if (hasValue) {
        $wrapper.addClass("selected");
    }
    else {
        $wrapper.removeClass("selected");
    }
}
